import defs from '../_core/defs.js';
import triggerOne from '../trigger/_triggerone.js';
import matreshkaError from '../_helpers/matreshkaerror.js';
import forEach from '../_helpers/foreach.js';
// removes given keys from a list of data keys
export default function removeDataKeys(givenKeys) {
  var _this = this;
  for (var _len = arguments.length, _rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    _rest[_key - 1] = arguments[_key];
  }
  var def = defs.get(this);
  /* istanbul ignore if */
  if (!def) {
    return this;
  }
  var keys = def.keys;
  var removedKeys;
  // accept an array keys or a list of args
  if (Array.isArray(givenKeys)) {
    removedKeys = givenKeys;
  } else {
    removedKeys = arguments;
  }
  forEach(removedKeys, function (key) {
    if (typeof key !== 'string') {
      throw matreshkaError('removedatakeys:key_type', {
        key: key
      });
    }
    if (key in keys) {
      var eventOptions = {
        key: key,
        value: _this[key]
      };
      delete keys[key];
      // undelegate asterisk listeners from the value (the handler skips a value another data key holds)
      triggerOne(_this, '_asterisk:remove', eventOptions);
      // fire "remove" and "modify" events
      triggerOne(_this, 'remove', eventOptions);
      triggerOne(_this, 'modify', eventOptions);
    }
  });
  return this;
}